import { IDisposable, editor, languages } from 'monaco-editor-core';
import { SQLITE_ID } from './constants';
import { grammar, config } from './sqlite';
import { SqliteLanguageService } from './sqlite.language.service';

export function setupMode(): IDisposable {
  const disposables: IDisposable[] = [];
  const providers: IDisposable[] = [];

  languages.setLanguageConfiguration(SQLITE_ID, config);

  const languageService = SqliteLanguageService.getInstance();

  editor.onDidCreateModel(model => {
    if (model.getLanguageId() !== SQLITE_ID) {
      return;
    }

    providers.push(
      model.onWillDispose(() => {
        languageService.unregisterModelOptions(model);
      })
    );
  });

  providers.push(languages.registerHoverProvider(SQLITE_ID, languageService));

  disposables.push(asDisposable(providers));

  return asDisposable(disposables);
}

function asDisposable(disposables: IDisposable[]): IDisposable {
  return { dispose: () => disposeAll(disposables) };
}

function disposeAll(disposables: IDisposable[]) {
  debugger;
  while (disposables.length) {
    disposables.pop()!.dispose();
  }
}

languages.register({
  id: SQLITE_ID,
});

languages.setMonarchTokensProvider(SQLITE_ID, grammar);

languages.onLanguage(SQLITE_ID, () => {
  setupMode();
});
